import React from 'react'

const Javanew = () => {
  return (
    <div>
              {/* collapseFour */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseFour"
                    aria-expanded="false" aria-controls="collapseFour">
                    Core Java
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Getting started - What is JAVA? Java Language Environment, Introduction to java language, JVM and its working, Features of java language, Difference between JDK, JRE and JVM</li>
                      <li>Basic Language Constructs - Data types, Operators in java, Conditional construct, Looping construct, Arrays, Scanner Class</li>
                      <li>OOP’s Concepts, OOP’s Features</li>
                      <li>Major Pillars of JAVA - Encapsulation, Abstraction, Inheritance, Polymorphism Creating classes and Objects - Declaring variable and accessing it. Types of Objects & Garbage Collection</li>
                      <li>Methods, Constructors, Use of Access Specifiers, static and This keyword</li>
                      <li>Inheritance- Type of inheritance, Concept of Polymorphism, Method Overloading, Method Overriding, Super Keyword.</li>
                      <li>Polymorphism- Final Keyword, Runtime Polymorphism, Abstract Classes, Interfaces</li>
                      <li>Packages, import and static import</li>
                      <li>String, Immutable String Comparison, String Concatenation, Substring, Methods of String class, StringBuffer class, StringBuilder class, String vs StringBuffer vs StringBuilder toString method.</li>
                      <li>Exception Handling - What is Exception, Exception type & hierarchy, Handling Exception using try - catch, throw & throws, Custom Exception, Finally Block.</li>
                      <li>Multithreading - What is Multithreading, Life Cycle of a Thread, Creating Thread, Thread States, Method of Thread with Examples, Synchronization in Multithreading</li>
                      <li>Collection Framework : ArrayList, LinkedList, List Interface, HashSet. LinkedHashSet, TreeSet, & Map Interface, HashMap, LinkedHashMap, Hashtable, Comparable Interface, Comparator Interface, Comparable vs Comparator.</li>
                      <li>Java Serialization use of transient keyword.</li>
                      <li>Java I/O - FileOutputStream, FileInputStream, BufferedOutputStream, BufferedInputStream, FileWriter, FileReader, BufferedWriter, BufferedReader</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseFive */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingFive">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseFive"
                    aria-expanded="false" aria-controls="collapseFive">
                    Advance Java
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>JDBC</strong>:
                    <ul>
                      <li>JDBC Introduction</li>
                      <li>JDBC DriverDB Connectivity, Steps Connectivity with StatementResultSet, PreparedStatement, ResultSetMetaData, DataBaseMetaDataStore</li>
                      <li>Operation like create, insert, update, delete, select, alter and from keyword values.</li>
                      <li>Stored procedure and its CallableStatement with examples.</li>
                    </ul>

                    <strong>Servlet & JSP</strong><br></br><br></br>

                    <strong>Spring</strong>:
                    <ul>
                      <li>What is Spring</li>
                      <li>IOC Container, Dependency Injection, Constructor Injection, CI Dependent Object, CI with Collection, CI with Map, Inheriting Bean Setter Injection.</li>
                      <li>SI Dependent Object, SI with Collection, Factory Method Spring Bean Autowiring Tutorial</li>
                      <li>Example On Spring Autowiring byName, Example On Spring Autowiring by Type, Example On Spring Autowiring by Constructor, Example On Spring Autowiring by Autodetect.</li>
                      <li>Spring AOP</li>
                      <li>AOP Concepts, Types of Advice with complete Explanation. Example On Spring AOP Before Advice, After Advice</li>
                      <li>Spring jdbc Template</li>
                      <li>Spring MVC</li>
                      <li>Spring MVC, Multiple ControllerRequest, Response, MVC Form</li>
                    </ul>

                    <strong>Hibernate</strong>:
                    <ul>
                      <li>HB Introduction</li>
                      <li>HB in Eclipse IDE</li>
                      <li>Hibernate Example, Hibernate - Annotations</li>
                      <li>Inheritance Mapping. Table Per Hierarchy. Table Per Hierarchy using Annotation.</li>
                      <li>Table Per Concrete, Table Per Concrete using Annotation.</li>
                      <li>Table Per Subclass, Table Per Subclass using Annotation</li>
                      <li>Collection Mapping</li>
                      <li>Component Mapping and Example</li>
                      <li>HQL : Hibernate query language and its Operation</li>
                      <li>Mapping - One to One, One to Many, Many to One, Many to Many Mapping</li>
                    </ul>

                    <strong>Spring Boot</strong>:
                    <ul>
                      <li>Spring Boot Introduction</li>
                      <li>Installation, Setup in eclipse</li>
                      <li>First Spring Boot Project - Hello World</li>
                      <li>Dispatcher Servlet</li>
                      <li>Dependency Injection</li>
                      <li>Autowiring</li>
                      <li>Spring Boot Application Properties</li>
                      <li>Client Server Mapping</li>
                      <li>@RequestParam Annotation</li>
                      <li>Spring Boot MVC - Model, View, Controller</li>
                      <li>Spring Boot CRUD Operations</li>
                      <li>JPA Custom queries with Query Method</li>
                      <li>Spring Boot Rest API</li>
                      <li>Spring Boot Rest API with Postman Tool</li>
                      <li>Spring Boot Security</li>
                      <li>Spring Boot - Thymeleaf</li>
                    </ul>

                    <strong>Micro Services</strong>:
                    <ul>
                      <li>Micro Services Introduction</li>
                      <li>Principle and Characteristics</li>
                      <li>Use Cases and Benefits</li>
                      <li>Challenges</li>
                      <li>Design Standards</li>
                      <li>Micro Services Communication</li>
                      <li>User Interfaces integration with Micro Services</li>
                    </ul>

                    <strong>REST API</strong>:
                    <ul>
                      <li>Introduction</li>
                      <li>Types – Private,Public, Partner</li>
                      <li>Serialization & Deserialization</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseSix */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingSix">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseSix"
                    aria-expanded="false" aria-controls="collapseSix">
                    Angular
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>What is Angular</li>
                      <li>Angular Installation</li>
                      <li>Create an Angular project</li>
                      <li>Angular File Structure & First App</li>
                      <li>Angular Architecture</li>
                      <li>Interpolation In Angular</li>
                      <li>Angular Components Functions, Events</li>
                      <li>Angular databinding</li>
                      <li>Angular with Bootstrap</li>
                      <li>Angular Forms with validation</li>
                      <li>Routing, Optional route parameters and Navigation</li>
                      <li>Angular pipes</li>
                      <li>Angular directives</li>
                      <li>Services API Call</li>
                      <li>HTTP and observables</li>
                      <li>Dependancy injection</li>
                      <li>Angular App & REST API Connectivity</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseSeven */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingSeven">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseSeven"
                    aria-expanded="false" aria-controls="collapseSeven">
                    React JS
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Introduction, History, Features</li>
                      <li>Installation - React environment, First React App</li>
                      <li>React ES6, JSX, Components</li>
                      <li>Angular Vs React Difference</li>
                      <li>Ways to rendering HTML</li>
                      <li>Functional Vs Class Components</li>
                      <li>Props, State, methods, Hooks - useState, useEffect, useContext, useRef, useReducer, useCallback, etc.</li>
                      <li>Event Handling, Forms, Conditional Rendering</li>
                      <li>Styling - CSS, CSS Modules, CSS-in-JS</li>
                      <li>React Router - Setup, routes, parameters</li>
                      <li>Async/await, Promises, API.</li>
                      <li>Axios package, CRUD Operation using Axios.</li>
                    </ul>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default Javanew